import { InputTypes } from "../InputTypes";

export const InternalNotes = Object.freeze({
  note: {
    visibleName: "Nota",
    type: InputTypes.TEXT,
  },
  time: {
    visibleName: "Timestamp",
    type: InputTypes.NUMBER,
  },
});
